export const identificationType = {
  doi: 'doi',
  pii: 'pii',
  document: 'document',
};

export const contentFamilyType = {
  serial: 'serial',
  nonserial: 'nonserial',
};

export const panelGroup = {
  connections: 'connections',
  enhancements: 'enhancements',
};

export const panelType = {
  author: 'author',
  articleInfo: 'articleInfo',
  citedBy: 'citedBy',
  citedByArticlePreview: 'citedByArticlePreview',
  connections: 'connections',
  connectionsArticlePreview: 'connectionsArticlePreview',
  figure: 'figure',
  figures: 'figures',
  outline: 'outline',
  recentPublicationsArticlePreview: 'recentPublicationsArticlePreview',
  recommendationsArticlePreview: 'recommendationsArticlePreview',
  reference: 'reference',
};

export const referenceType = {
  bibliography: 'bib-reference',
  figure: 'figure',
};
